import * as React from "react"
import {Divider, Grid} from "@mui/material";
import {CardSeeker} from "@ui-seeker/core";

import RepricingCrudFormScopeRow from "./ScopeRow";
import RepricingCrudFormSubmitBlock from "./SubmitBlock";
import RepricingCrudFormScheduleRow from "./ScheduleRow";
import RepricingCrudFormActionRow from "./ActionRow";
import RepricingFormNameTextField from "./Name";
import RepricingCrudFormSetUpRow from "./SetUpRow";


export default function RepricingCrudForm() {

	return <CardSeeker>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<RepricingFormNameTextField />
			</Grid>

			<Grid item xs={12}>
				<Divider />
			</Grid>

			<RepricingCrudFormScopeRow />

			<Grid item xs={12}>
				<Divider />
			</Grid>

			<RepricingCrudFormSetUpRow />

			<Grid item xs={9} />

			<Grid item xs={12}>
				<Divider />
			</Grid>

			<RepricingCrudFormActionRow />

			<Grid item xs={12}>
				<Divider />
			</Grid>

			<RepricingCrudFormScheduleRow />

			<Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
				<RepricingCrudFormSubmitBlock />
			</Grid>
		</Grid>
	</CardSeeker>
}